import { size, get } from 'lodash';
import {
  takeEvery,
  put,
  select,
  take,
  delay,
  fork,
  cancel,
  call,
} from 'redux-saga/effects';
import {
  actions as removeNotificationsCounters,
  consts as removeCounters,
} from '../removeNotificationsCounters';
import {
  actions as notificationCounterActions,
  consts as notificationCounters,
} from '../notificationCounters';
import { consts as userCommunities } from '../userCommunities';

import { communityUnreadCountSelector } from '../selectors/selectors';
import {
  consts as communitiesJoinRequests,
  actions as communityJounRequestsActions,
  paginatedConsts,
} from '../communitiesJoinRequests';
import { ACTIVITY_TYPES } from '../../../constants';
import { selectActivityListByType } from '../selectors/activitiesSelector';

function* removeNotificationCountersWorker(action) {
  const { payload } = action;
  const { type, community_ids: communityIds } = payload;
  yield take(removeCounters.SUCCEED);
  if (type === 'communities') {
    const communityId = communityIds[0];
    const currentCommunityCounter = yield select(
      communityUnreadCountSelector(communityId),
    );
    yield put({
      type: notificationCounters.UPDATE_COMMUNITY_COUNT,
      payload: -currentCommunityCounter,
    });
    yield put({
      type: userCommunities.UPDATE_TOTAL_UNREAD_COUNT,
      payload: { communityId, removeCounter: true },
    });
  }
}

function getUnreadIds(list = []) {
  return list.filter(({ status }) => status === 'unread').map(({ id }) => id);
}

function isNotificationRealTime(type, payload) {
  return (
    type === communitiesJoinRequests.REAL_TIME_INSERT &&
    get(payload, 'type') === ACTIVITY_TYPES.NOTIFICATIONS
  );
}

function* handleRealTimeInsert({ type, payload }) {
  if (!isNotificationRealTime(type, payload)) {
    yield cancel();
  }

  yield call(handleFetchNotificationList);
}

function* handleFetchNotificationList() {
  const notificationList = yield select(
    selectActivityListByType(ACTIVITY_TYPES.NOTIFICATIONS),
  );
  const unreadIds = getUnreadIds(notificationList);
  const unreadSize = size(unreadIds);

  if (unreadSize) {
    yield put(
      removeNotificationsCounters.send({
        type: 'activities',
        meta: ACTIVITY_TYPES.NOTIFICATIONS,
        notificationIds: unreadIds,
      }),
    );

    yield put(notificationCounterActions.updateActivityCount(unreadSize * -1));

    const clearTask = yield fork(function* asyncClear() {
      yield delay(10e3);
      yield put(
        communityJounRequestsActions.resetIsNewFlag({
          type: ACTIVITY_TYPES.NOTIFICATIONS,
          ids: [...unreadIds],
        }),
      );
    });

    yield takeEvery(
      [communitiesJoinRequests.PAGE_LEAVE],
      function* leavePage() {
        yield cancel(clearTask);
      },
    );
  }
}

export default function* removeNotificationCountersSaga() {
  yield takeEvery(removeCounters.SEND, removeNotificationCountersWorker);

  yield takeEvery(
    [communitiesJoinRequests.SUCCEED, paginatedConsts.SUCCEED],
    handleFetchNotificationList,
  );

  yield takeEvery(
    communitiesJoinRequests.REAL_TIME_INSERT,
    handleRealTimeInsert,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/removeNotificationsCounters.js